import { isValid, iterateRules, RuleDefinition, RuleDefinitionType } from '../ruleDefinition';

// A condition with nothing in it, or with a part not filled in, is not checked at all: the
// handler that checks conditions lets everything through then, while a rule then doesn't hold.
export function isConditionComplete(condition: RuleDefinition) {
	const parts = [...iterateRules(condition)];
	return parts.some((part) => part.type == RuleDefinitionType.Rule) && isValid(condition);
}
